/**
 * Get all riot tags
 */
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/braintree-payment.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/checkout-item.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/checkout-modal.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/checkout-payment.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/checkout-shipping.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/checkout-summary.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/swish-handel-payment.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/invoice-payment.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/swish-app2app-payment.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/swish-modal-body.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/swish-app2app-modal-body.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal-abort.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal-error.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal-form.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal-success.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-modal-abort.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-modal-error.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-modal-form.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-modal-success.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-modal.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/tags/feature-feedback-widget.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/tags/modal.riot.html";
import "../../src/EbaySweden.TouchWeb/static/script/tags/pagination.riot.html"; 


// WEBPACK FOOTER //
// ./build/templates/riot-core-tags.js